import React from 'react';
import './AboutPage.css';

// Import images
import teacherImage from '../assets/images/teacher-4784916_1920.jpg';
import childrenImage from '../assets/images/children-1311506_1920.jpg';

const AboutPage = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <div className="hero-content text-center">
            <div className="logo-container">
              <img 
                src="https://static.wixstatic.com/media/1d90b3_588e219d6cc2449d84256529ea18235d~mv2.png" 
                alt="Digital Flourishing for Young Minds" 
                className="page-logo"
              />
            </div>
            <h1>About Digital Flourishing for Young Minds</h1>
            <p className="hero-description">
              Empowering educators and families to create healthier digital relationships 
              for the next generation through evidence-based programs and practical tools.
            </p>
          </div>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="section section-white">
        <div className="container">
          <div className="story-content">
            <div className="story-text">
              <h2>Our Story</h2>
              <p>
                Digital Flourishing for Young Minds was born from a simple observation: while technology 
                offers incredible opportunities for learning and connection, many young people struggle 
                to develop healthy digital habits without proper guidance.
              </p>
              <p>
                Founded by educators and digital wellness experts, our program bridges the gap between 
                the digital world and real-world wellbeing. We believe that with the right tools, 
                knowledge, and support, every young person can learn to use technology in ways that 
                enhance rather than detract from their flourishing.
              </p>
              <p>
                Our evidence-based approach has been developed through extensive research and tested 
                in schools across the UK, consistently delivering measurable improvements in 
                student focus, digital awareness, and overall wellbeing.
              </p>
            </div>
            <div className="story-image">
              <img src={teacherImage} alt="Teacher working with students" />
            </div>
          </div>
        </div>
      </section>

      {/* Our Mission Section */}
      <section className="section section-light">
        <div className="container">
          <div className="mission-content">
            <div className="mission-image">
              <img src={childrenImage} alt="Children learning together" />
            </div>
            <div className="mission-text">
              <h2>Our Mission</h2>
              <p>
                To empower educators, parents, and young people with the knowledge, skills, and 
                tools needed to create positive digital cultures that support learning, wellbeing, 
                and human flourishing.
              </p>
              
              <div className="values">
                <h3>Our Core Values</h3>
                <div className="value-item">
                  <h4>Evidence-Based</h4>
                  <p>All our programs are grounded in research and continuously refined based on real-world outcomes.</p>
                </div>
                <div className="value-item">
                  <h4>Practical</h4>
                  <p>We provide actionable strategies that can be immediately implemented in schools and homes.</p>
                </div>
                <div className="value-item">
                  <h4>Collaborative</h4>
                  <p>We believe lasting change happens when educators, parents, and students work together.</p>
                </div>
                <div className="value-item">
                  <h4>Empowering</h4>
                  <p>Our goal is to build capacity and confidence, not create dependency on external solutions.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="section section-teal">
        <div className="container text-center">
          <h2 style={{color: 'white', marginBottom: '1rem'}}>Ready to Transform Your School's Digital Culture?</h2>
          <p style={{color: 'white', fontSize: '1.2rem', marginBottom: '2rem'}}>
            Join the growing community of educators creating healthier digital environments for young minds.
          </p>
          <button className="btn btn-secondary">
            Contact Us to Learn More
          </button>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
